// angular dependencies
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';

// shared dependencies
import { LongPressDirective } from '@fantaz/shared/directives/long-press';
import { SharedDirectivesSrcErrorModule } from '@fantaz/shared/directives/src-error';
import { CurrencyModule } from '@fantaz/shared/ui/currency';
import { MaterialModule } from '@fantaz/shared/ui/material';

// local dependencies
import { GameCardImageComponent } from './components/card-image/card-image.component';
import { CardStatusComponent } from './components/card-status/card-status.component';
import { FzGameCardTagsComponent } from './components/card-tags/game-card-tags..component';
import { GameCardTimeComponent } from './components/card-time/card-time.component';
import { GameCardDescriptionComponent } from './components/description/description.component';
import { GameCardRoomDetailsComponent } from './components/details/details.component';
import { GameCardRoomNumberComponent } from './components/number/number.component';
import { GameCardPrizeDescriptionComponent } from './components/prize-description/prize-description.component';
import { GameCardPrizeComponent } from './components/prize/prize.component';
import { GameCardComponent } from './game-card.component';

const COMPONENTS: any[] = [
  GameCardComponent,
  GameCardPrizeComponent,
  GameCardTimeComponent,
  GameCardPrizeDescriptionComponent,
  FzGameCardTagsComponent,
  GameCardRoomNumberComponent,
  GameCardRoomDetailsComponent,
  GameCardDescriptionComponent,
  GameCardImageComponent,
  CardStatusComponent,
];

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    MatRippleModule,
    SharedDirectivesSrcErrorModule,
    CurrencyModule,
    LongPressDirective,
  ],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
  providers: [],
})
export class GameCardModule {}
